export const ACCEPTED_IMAGE_EXTENSIONS = [
  'jpg', 'jpeg', 'png', 'gif', 'bmp', 'tif', 'tiff', 'webp', 'heic', 'heif'
];

export const ACCEPTED_IMAGE_MIME_TYPES = [
  'image/jpg',
  'image/jpeg',
  'image/pjpeg',
  'image/png',
  'image/gif',
  'image/bmp',
  'image/x-ms-bmp',
  'image/tif',
  'image/tiff',
  'image/webp',
  'image/heic',
  'image/heif'
];

export const ACCEPTED_IMAGE_INPUT_ACCEPT = [
  ...ACCEPTED_IMAGE_MIME_TYPES,
  ...ACCEPTED_IMAGE_EXTENSIONS.map((extension) => `.${extension}`)
].join(',');

export const ACCEPTED_IMAGE_EXTENSIONS_LABEL = ACCEPTED_IMAGE_EXTENSIONS
  .map((extension) => extension.toUpperCase())
  .join(', ');

export const fileExtension = (fileName) => {
  const name = fileName || '';
  const index = name.lastIndexOf('.');
  return index === -1 ? '' : name.slice(index + 1).toLowerCase();
};

export const isAcceptedImageFile = (file) => {
  if (!file) return false;

  const extension = fileExtension(file.name);
  if (extension) return ACCEPTED_IMAGE_EXTENSIONS.includes(extension);

  const mimeType = (file.type || '').split(';')[0].trim().toLowerCase();

  return ACCEPTED_IMAGE_MIME_TYPES.includes(mimeType);
};
